<template>
  <div>
    <div class="css-grid pay-invoice-form__row pay-invoice-form__row--header pay-invoice-form__row--success">
      <div></div>
      <div class="pay-invoice-view__cell pay-invoice-view__cell--header">Payment Received</div>
      <div></div>
    </div>

    <div class="panel">
      <div class="css-grid pay-invoice-form__row">
        <div></div>
        <div class="pay-invoice__message pay-invoice__message--success">
          Thank you. Your payment has been received. You'll receive an email confirmation.
        </div>
        <div></div>
      </div>

    </div>

    <div class="panel pay-invoice__nav-row h-center-align">
      <button class="btn btn-primary" @click.prevent="nextStep">Pay Another Invoice</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SuccessMessageView',
    methods: {
      nextStep() {
        this.$store.dispatch('payInvoice/resetForm');
      },
    },
  }
</script>
